import { useEffect } from "react";
import "../../css/style.css";
import Base from "../../../Base/views/Base";
import ManageGoal from "../ManageGoal/Managegoal";
import FeedBack from "../Feedback/Feedback";
import DashboardActionPage from "./DashboardActionPage";
import { Box } from "@mui/material";
import ContinuousPerformance from "../Performance/ContinuousPerformance";
import ReviewLandingPage from "../Review/ReviewLandingPage";
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AddMenuHeadingAction } from "../../../../../store/Menu/Action";


export default function Dashboard() {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  useEffect(() => {
      sessionStorage.setItem("selectedMenu", "Achievement Orchestrator");
      dispatch(AddMenuHeadingAction({ heading: "Achievement Orchestrator" }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
      <Base>
        <Box sx={{
            height: "calc(100vh - 65px)",
            overflowY: "auto",
            pb: 1,
          }}>
           <Switch>
          {/* Default dashboard */}
          <Route exact path={path} component={DashboardActionPage} />

          {/* Child routes */}
          <Route path={`${path}/goals`} component={ManageGoal} />
          <Route path={`${path}/feedback`} component={FeedBack} />
          <Route path={`${path}/performance`} component={ContinuousPerformance} />
          <Route path={`${path}/review`} component={ReviewLandingPage} />

          {/* Fallback */}
          <Redirect to={path} />
        </Switch>
        </Box>
      </Base>
  );
}

